<template>
  <div class="main">
    <Title title="Clientes" />
    <div class="wrapper-clients">
      <div class="above-table">
        <Searcher v-model:search="query" />
        <StandardButton
          :buttonLabel="'Crear cliente'"
          @click="createClientOption"
        />
      </div>
      <div class="wrapper-table">
        <table class="table-users">
          <thead>
            <tr>
              <th>Identificación</th>
              <th>No. identificación</th>
              <th>Empresa</th>
              <th>Contacto</th>
              <th>Teléfono</th>
              <th>Correo</th>
              <th>Facturación</th>
              <th>Editar</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(client, index) in filteredClients" :key="index">
              <td>{{ client.identificationType }}</td>
              <td>{{ client.identificationNumber }}</td>
              <td>{{ client.company }}</td>
              <td>{{ client.contactName }}</td>
              <td>{{ client.contactEmail }}</td>
              <td>{{ client.contactPhone }}</td>
              <td>{{ client.billingEmail }}</td>
              <td>
                <img
                  src="assets/administrator/Edit.svg"
                  alt="edit"
                  class="icon-table"
                  @click="editTransaction(client)"
                />
              </td>
              <td>
                <img
                  src="assets/administrator/Delete.svg"
                  alt="delete"
                  class="icon-table"
                  @click="selectDeletedClient(client)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import Title from "../layoutAdmin/components/Title.vue";
import Searcher from "@/components/commons/controls/AdminSearcher.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import { clientsUse } from "../clients/use/clientsUse";
import { Client } from "@/business/clients/domain/clients";

export default defineComponent({
  name: "ClientsView",
  components: { Title, Searcher, StandardButton },
  setup() {
    const {
      createClientOption,
      clients,
      query,
      editClientOption,
      deleteTheClient,
      clientSelected,
      filteredClients,
    } = clientsUse();

    async function editTransaction(client: Client) {
      await editClientOption(client.clientId);
    }

    async function selectDeletedClient(client: Client) {
      clientSelected.value = client;
    }

    async function deleteThisClient() {
      await deleteTheClient();
    }

    return {
      createClientOption,
      clients,
      query,
      editTransaction,
      selectDeletedClient,
      deleteThisClient,
      deleteTheClient,
      filteredClients,
    };
  },
});
</script>


<style scoped lang="scss">
@import "src/ux/admin/clients/styles/clientsStyle";
</style>
